"use strict";

angular.module("models").service("DepasService", ["ApiService", function (ApiService) {
  var that = this;

  var params = {
    name: "depas",
    attributesForCache: ["status", "shortId", "emailToUse", "phoneToUse"],
    formatName: function formatName(element) {
      return element.name ? element.name : "???";
    },
    defaultOrder: { creationDate: -1 }
  };

  angular.extend(that, ApiService.getModelBis(params));
}]);